import { Analytics } from 'common-frontend'
import DoneIcon from 'material-ui/svg-icons/action/done'

import { Button, SimpleDialog, HelpEmail } from 'components'
import { ExtendedUserActions, PlusActions } from 'actions'
import { APP_NAME, SUPPORT_EMAIL } from 'consts'
import { AnalyticsUtils } from 'utils'

import './chargeContainer.scss'

const setupBenefits = [
  'Create keyword optimized page titles for better ranking',
  'Generate compelling meta descriptions that get clicked',
  'Automatically add JSON-LD structured data to your shop',
  'Detect broken links and redirect your customers',
  "Integrate with Google's search console",
]

export default class ChargeContainer extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    currentUser: React.PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    const events = ['success', 'failed', 'declined']
    const event = this.props.params.event

    this.state = {
      event,
      showModal: events.includes(event),
      message: '',
      title: '',
      actionButtonLabel: 'Close',
    }
  }

  componentWillMount() {
    if (this.state.event === 'success') {
      // This is fairly naive for now and only takes into account existing pricing

      if (!this.context.currentUser.startedFreeTrial) {
        const appPlan = this.context.currentUser.appPlan
        if (appPlan != 'staff_business_plus' && appPlan != 'affiliate_plus') {
          ExtendedUserActions.update({ started_free_trial: true })
          AnalyticsUtils.startedTrial(this.context.currentUser.email)
        }
      }

      PlusActions.upgradeToPlus(this.context.currentUser)
      this.context.router.replace('/install/seo')

      return
    }

    if (this.state.event === 'failed') {
      this.setState({
        title: 'Upgrade failed',
        message: (
          <p>
            An error occurred. You have not been charged. Please email{' '}
            <HelpEmail /> with this error message
          </p>
        ),
        actionButtonLabel: <span>I've emailed {SUPPORT_EMAIL}</span>,
      })
    } else if (this.state.event === 'declined') {
      this.setState({
        title: 'Upgrade declined',
        message: (
          <div>
            <p>
              Charge declined. Have any questions before upgrading? Email us at{' '}
              <HelpEmail /> and we&apos;ll be happy to answer them
            </p>
          </div>
        ),
        actionButtonLabel: 'Close',
      })
    } else {
      this.context.router.push('/')
    }
  }

  onDialogClose = () => {
    if (this.state.event !== 'success') {
      this.context.router.push('/')
      return
    }

    this.context.router.replace('/plus/manage')
  }

  onInstallLongOnboarding = () => {
    this.context.router.replace('/install/seo')
  }

  render() {
    if (this.state.event == 'success') return this.renderWelcome()
    return (
      <SimpleDialog
        title={this.state.title}
        message={this.state.message}
        open={this.state.showModal}
        onClose={this.onDialogClose}
        modal={true}
        actionButtonLabel={this.state.actionButtonLabel}
      />
    )
  }

  renderWelcomeContent() {
    return (
      <div className="welcome__variant-b-container">
        <h1 className="large-spacing--bottom">
          Install and Start Improving Your SEO
        </h1>
        <div className="welcome__benefits xlarge-spacing--bottom">
          {setupBenefits.map((benefit, index) => (
            <div
              className="welcome__benefits__item medium-spacing--bottom"
              key={`benefit-${index}`}
            >
              <DoneIcon color="#49A74C" />
              <span className="label small-spacing--left">{benefit}</span>
            </div>
          ))}
        </div>
        <p className="welcome__buttons">
          <Button
            label="Install Plug in SEO"
            buttonType="primary"
            onTouchTap={this.onInstallLongOnboarding}
          />
          <Button
            label="Not now, I'm just browsing"
            buttonType="secondary"
            onTouchTap={() => {
              Analytics.track("'Just Browsing' Button Clicked", {
                email: this.context.currentUser.email,
              })
              this.onDialogClose()
            }}
            className="secondary-btn"
          />
        </p>
      </div>
    )
  }

  renderWelcome() {
    return (
      <div className="welcome">
        <div className="setup-logo-container">
          <img
            className="setup-brand-symbol"
            alt="Plug in Useful"
            src="../../assets/images/brand-symbol.png"
          />
          <img
            className="setup-logo"
            alt={APP_NAME}
            src="../../assets/images/logo-color.png"
          />
        </div>
        {this.renderWelcomeContent()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/ChargeContainer.js